export function isImageMimeType(type: string): boolean {
  return /image\/.*/.test(type);
}
